import { render, staticRenderFns } from "./ebooks.vue?vue&type=template&id=33850105&scoped=true&"
import script from "./ebooks.vue?vue&type=script&lang=js&"
export * from "./ebooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33850105",
  null
  
)

export default component.exports